import _ from 'lodash';
import { AT } from '../../actions/actionTypes';

import DTReducer from '../datatable/reducer';
import { resetState } from '../datatable/utils';
import { StateDefault } from './defaults';
import { State, FilterCriteria } from './model';
import { PREFIX as DTYPE_PREFIX } from './actiontypes';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const mapActionType = (actionType: string): string =>
  _.values(AT.DTYPES).indexOf(actionType) !== -1
    ? _.replace(actionType, DTYPE_PREFIX, '')
    : '';

export default function (state = StateDefault, action: any): State {
  const dtActionType = { ...action, type: mapActionType(action.type) };
  const stateAfterDT: State = {
    ...state,
    ...DTReducer(state, dtActionType),
  };

  switch (action.type) {
    case AT.DTYPES.FILTER_CRITERIA_UPADATED: {
      Logger.info(
        [AT.DTYPES.FILTER_CRITERIA_UPADATED, action],
        LogArea.Redux
      );
      const filters: FilterCriteria = action.payload;
      return { ...stateAfterDT, ...resetState(stateAfterDT), filters };
    }

    case AT.DTYPES.TABLE_COLUMNS: {
      Logger.info([AT.DTYPES.TABLE_COLUMNS, action], LogArea.Redux);
      const table = { ...stateAfterDT.table, columns: action.payload };
      return { ...stateAfterDT, table };
    }

    case AT.DTYPES.RESET:
      Logger.info([AT.DTYPES.RESET], LogArea.Redux);
      return { ...stateAfterDT, ...resetState(stateAfterDT) };

    default: {
      return stateAfterDT;
    }
  }
}
